// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a8986cdc","845":"9a37166f"}[chunkId] + ".chunk.js";
};